import React from 'react'
import PropTypes from 'prop-types'
import { ControlLabel, FormGroup, HelpBlock } from 'react-bootstrap'

const stripeElementStyle = {
  base: {
    color: '#555555',
    // Montserrat is free and looks like Gotham. We can't use Gotham because of CORS restrictions.
    // Be sure to pass Montserrat CSS source when instantiating Elements
    fontFamily: '"Montserrat", "Gotham Book", "Gotham", sans-serif',
    fontSize: '16px',
    fontSmoothing: 'antialiased',
    fontWeight: 400,
    lineHeight: '1.5',
    '::placeholder': {
      color: '#999999',
    },
  },
  invalid: {
    color: '#555555',
  },
}

// Used to wrap a Stripe Elements component and make it look like a Babylist input
export default class ElementField extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    elementComponent: PropTypes.func.isRequired, // stripe element is a func, not a node
    error: PropTypes.string,
    label: PropTypes.string,
  }

  render() {
    const { className, error, label } = this.props
    const ElementComponent = this.props.elementComponent
    return (
      <FormGroup className={className} validationState={error ? 'error' : null}>
        {label ? <ControlLabel>{label}</ControlLabel> : null}
        <ElementComponent
          className="form-control mbm"
          style={stripeElementStyle}
        />
        {error ? <HelpBlock className="h6">{error}</HelpBlock> : null}
      </FormGroup>
    )
  }
}
